import { useParams } from "react-router";
import React from "react";
import { cn } from "~/lib/utils";
import { LANG } from "~/utils/constant";
type PropsType = {
  number: number;
};
const DisplayPart: React.FC<PropsType> = ({ number }) => {
  const lang = useParams().lang || "en";
  return <p className={cn("body_text_s text-textHeadingColor ", lang === LANG.english ? "md:mt-1" : "")}>{`(${number})`}</p>;
};

export default DisplayPart;
